import { render, staticRenderFns } from "./caneDetail.vue?vue&type=template&id=045d9304&scoped=true"
import script from "./caneDetail.vue?vue&type=script&lang=js"
export * from "./caneDetail.vue?vue&type=script&lang=js"
import style0 from "./caneDetail.vue?vue&type=style&index=0&id=045d9304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d9304",
  null
  
)

export default component.exports